import React from 'react'
import styled from 'styled-components'
import {useSelector} from "react-redux";
import {
    LabelEvent,
    LabelHitBox,
    LabelRankingBox,
    LabelStdpc,
    WrapperLabelHit
} from "../../common/label.style";
import StockLabelComponent from "../../common/stockLabel";

const ItemLabel = ({ data }) => {
    const { sort } = useSelector((state) => state.initial.route)

    return (
        <Style className="top_label">
            {data.ranking !== 0 && sort === 'rank' &&
                <WrapperLabelHit>
                    <LabelHitBox>HIT</LabelHitBox>
                    <LabelRankingBox>{data.ranking}</LabelRankingBox>
                </WrapperLabelHit>
            }
            {data.cnt_firm_b2 > 0 &&
                <StockLabelComponent
                    isShow={data.cnt_firm_b2 > 0}
                    labelWidth='56'
                    labelHeight='19'
                />
            }
            {data.isStdpc !== 0 && <LabelStdpc>표준부품</LabelStdpc>}
            {data.isEvent !== 0 && <LabelEvent>이벤트</LabelEvent>}
            {data.isHotDeal !== 0 && <span className="label hotdeal">행복핫딜</span>}
        </Style>
    )
}

const Style = styled.div`
    margin: 0 0 8px;
    display : flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    .label {
        position: relative;
        border: 1px solid #333;
        display: inline-block;
        font-weight: normal;
        height: 19px;
        line-height: 17px;
        padding: 0 3px;
        text-align: center;
        vertical-align: middle;
        cursor: default;

        & + .label {
            margin: 0 0 0 3px
        }
        &.hit {
            padding: 0 4px 0 28px;
            color: #0f4f9f;

            &:before {
                content: 'HIT';
                position: absolute;
                top: 0;
                left: 0;
                width: 24px;
                height: 18px;
                line-height: 18px;
                background: #0f4f9f;
                color: #fff;
                text-align: center;
            }
        }
        &.std {
            border-color: #f34522;
            color: #f34522;
        }
        &.event {
            border-color: #f47300;
            color: #f47300;
        }
        &.hotdeal {
            border-color: #db00f5;
            color: #db00f5;
        }
        &.stdpc {
            border-color: #3366cc;
            color: #3366cc;
        }
        &.gift {
            border-color: #0bb0c5;
            color: #0bb0c5;
        }
        &.stock {
            border-color: #005796;
            color: #005796;
        }
    }
`


export default ItemLabel



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/item_label.js